import React from 'react';
import {
  Form, Checkbox, Spin, Icon,
} from 'antd';
import {
  Box,
} from '../../shared/components';
import InlineCard from '../components/InlineCard';

export default function ProveedoresTab({
  proveedores, form, noConformidades,
  onChangeProveedoresSeleccionados, proveedoresSeleccionados,
}) {
  const { getFieldDecorator } = form;
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  let content = '';
  const { listado, loading } = proveedores;
  const { seleccionada } = noConformidades;
  let { proveedores: proveedoresArray } = seleccionada;
  proveedoresArray = (typeof (proveedoresArray) !== 'undefined') ? proveedoresArray : [];

  if (!Array.isArray(proveedoresArray)) {
    proveedoresArray = proveedoresArray.split(',');
  }

  for (let i = 0; i < proveedoresArray.length; i += 1) {
    if (proveedoresArray[i] !== undefined) {
      proveedoresArray[i] = parseInt(proveedoresArray[i], 10);
    }
  }

  content = (
    <InlineCard
      headerText="PROVEEDORES"
      content={(
        <Box px={5} py={3}>
          <Spin indicator={antIcon} spinning={loading} size="large">
            {listado.map(item => (
              <Form.Item key={item.id}>
                {getFieldDecorator(`proveedores[${item.id}]`, {
                  initialValue: (proveedoresArray.indexOf(item.id) >= 0) || (proveedoresSeleccionados.filter(valor => valor === item.id).length > 0),
                  valuePropName: 'checked',
                })(
                  <Checkbox idProveedor={item.id} onChange={e => onChangeProveedoresSeleccionados(e)}>{item.razon}</Checkbox>,
                )}
              </Form.Item>
            ))}
          </Spin>
        </Box>
      )}
    />
  );

  return content;
}
